import React from 'react';

import { useSelector } from 'react-redux';

import { LearnMoreAboutFindings } from 'components/DataDisplay';
import { ColumnLabelsInSnowflake } from 'components/DataDisplay/KnowledgeBase/Components/ColumnLabelsInSnowflake';
import { HowDoesCreatePolicyWork } from 'components/DataDisplay/KnowledgeBase/Components/HowDoesCreatePolicyWork';
import { LearnMoreAboutActivityGroup } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutActivityGroup';
import { LearnMoreAboutAriksaOutposts } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutAriksaOutposts';
import { LearnMoreAboutBlueprints } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutBlueprints';
import { LearnMoreAboutCompliance } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutCompliance';
import { LearnMoreAboutDataGroup } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutDataGroup';
import { LearnMoreAboutDataPolicy } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutDataPolicy';
import { LearnMoreAboutEnvironments } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutEnvironments';
import { LearnMoreAboutExceptions } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutExceptions';
import { LearnMoreAboutIssues } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutIssues';
import { LearnMoreAboutJiraProjectDefaultBoard } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutJiraProjectDefaultBoard';
import { LearnMoreAboutJiraProjectSummaryPrefix } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutJiraProjectSummaryPrefix';
import { LearnMoreAboutJITApprovals } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutJITApprovals';
import { LearnMoreAboutPolicies } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutPolicies';
import { LearnMoreAboutRemediation } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutRemediation';
import { LearnMoreAboutTicketing } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutTicketing';
import { LearnMoreAboutVulnerabilityManagement } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutVulnerabilityManagement';
import { LearnMoreAboutVulnerabilityScan } from 'components/DataDisplay/KnowledgeBase/Components/LearnMoreAboutVulnerabilityScan';
import { selectSharedState } from 'containers/SharedState/selectors';

export const LearnMore = () => {
  const { learnMore } = useSelector(selectSharedState);
  const getComponents = () => {
    switch (learnMore) {
      case 'findings':
        return <LearnMoreAboutFindings />;
      case 'issues':
        return <LearnMoreAboutIssues />;
      case 'create_policy':
        return <HowDoesCreatePolicyWork />;
      case 'data_policy':
        return <LearnMoreAboutDataPolicy />;
      case 'column_labels_in_snowflake':
        return <ColumnLabelsInSnowflake />;
      case 'ticketing':
        return <LearnMoreAboutTicketing />;
      case 'remediation':
        return <LearnMoreAboutRemediation />;
      case 'vulnerability_management':
        return <LearnMoreAboutVulnerabilityManagement />;
      case 'vulnerability_scan':
        return <LearnMoreAboutVulnerabilityScan />;
      case 'compliance':
        return <LearnMoreAboutCompliance />;
      case 'blueprints':
        return <LearnMoreAboutBlueprints />;
      case 'policies':
        return <LearnMoreAboutPolicies />;
      case 'environments':
        return <LearnMoreAboutEnvironments />;
      case 'exceptions':
        return <LearnMoreAboutExceptions />;
      case 'jira_project_summary_prefix':
        return <LearnMoreAboutJiraProjectSummaryPrefix />;
      case 'jira_project_default_board':
        return <LearnMoreAboutJiraProjectDefaultBoard />;
      case 'data_group':
        return <LearnMoreAboutDataGroup />;
      case 'activity_group':
        return <LearnMoreAboutActivityGroup />;
      case 'jit_approvals':
        return <LearnMoreAboutJITApprovals />;
      case 'ariksa_outposts':
        return <LearnMoreAboutAriksaOutposts />;
    }
  };
  return <>{getComponents()}</>;
};
